import useSettings from '../settings/useSettings.js';
import { useEffect } from 'react';

const useSiteImprove = () => {
    const settings = useSettings();

    useEffect(() => {
        const siteImproveId = settings.get('SiteImprove ID');
        if (!siteImproveId) return;

        const script = document.createElement('script');
        script.src = `https://siteimproveanalytics.com/js/siteanalyze_${siteImproveId}.js`;
        script.async = true;
        document.body.appendChild(script);

        return () => {
            if (script.parentNode) {
                document.body.removeChild(script);
            }
        };
    }, [settings]);
};

export default useSiteImprove;